import React from "react";
import Layout from "../../Layout/Layout.jsx";
import { withRouter } from "react-router";
import withStyles from "@material-ui/core/styles/withStyles";
import componentsStyle from "../../assets/jss/material-kit-react/views/components.jsx";
import SectionProjects from "./SectionProjects.jsx";
class Publications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components,
    };
    console.log(this.state.language);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      language: window.language.setLanguage(newProps.match.params.lang)
        .components,
    });
  }

  render() {
    return (
      <Layout language={this.state.language} color="white" {...this.props}>
        <SectionProjects
          {...this.state.language.publication}
          lang={this.state.language.lang}
        />
      </Layout>
    );
  }
}

export default withRouter(withStyles(componentsStyle)(Publications));



// WEBPACK FOOTER //
// ./src/views/Publications/Publications.jsx